export const routeName = {
  LOGIN: '/login',
  BRANDS: '/',
  EDITBRANDS: '/brands/:id',
  PRODUCTS: '/products/',
  EDITPRODUCT: '/products/:id',
  USERS: '/users',
  EDITUSER: '/users/:id',
  EDITPORT: '/ports/:id',
  PORTS: '/ports',
  ADDCOMMISSION: '/commissions/add',
  PROMOTIONS: '/promotions',
  COMMISSION_DETAIL: '/commissions/:id',
  CATEGORIES: '/categories',
  BLOGS: '/blogs',
  EDITBLOG: '/blogs/:id',
  TAGS: '/tags'
};
